import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';
import style from './print-modal-content.module.less';

export const BrowserPrintTip = ({ downloadAndPrintDisabled = false, onDownload = noop }) => {
  return (
    <div>
      <div className={style['second-level-heading']}>
        <FormattedMessage defaultMessage='Browser Print' description='printModal.printFromBrowser' id='2A3tel' />
      </div>
      <div className={style['browser-print-tip']}>
        <FormattedMessage
          defaultMessage='Hover the cursor over the preview window to access browser printing, or download the document using the <b>Download</b> button.'
          description='printModal.browserPrintHelp'
          id='YJW3Zi'
          values={{ b: (chunks) => <b>{chunks}</b> }}
        />
      </div>
      <Button
        className={style['download-button']}
        disabled={downloadAndPrintDisabled}
        onClick={onDownload}
        testId='print-modal-download'
        theme='tertiary'
      >
        <FormattedMessage defaultMessage='Download' description='printModal.downloadButton' id='GYUCQ9' />
      </Button>
    </div>
  );
};

BrowserPrintTip.propTypes = {
  downloadAndPrintDisabled: PropTypes.bool,
  onDownload: PropTypes.func,
};
